import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import config from '../config/app';
export default {
  data() {
    return {
      companyDataLocal: {},
    };
  },
  computed: {
    ...mapGetters('auth', ['getAuthenticatedUser', 'getActiveContactType']),
    ...mapGetters('company', ['getContactLoginSlug']),
  },
  async mounted() {
    if (this.getContactLoginSlug && this.getContactLoginSlug._id) {
      this.companyDataLocal = { ...this.getContactLoginSlug };
    }
  },
  methods: {
    logoutUser() {
      Swal.fire({
        title: '',
        html: 'signing off....',
        timer: 3000,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
          Swal.showLoading();
          // Reset theme BEFORE clearing localStorage
          this.$store.dispatch('theme/resetTheme', null, { root: true });
          localStorage.removeItem(config.APP_NAME + '_' + config.APP_VERSION);
          localStorage.clear();
          this.resetStore();
        },
        willClose: () => {
          if (this.companyDataLocal?.slug) {
            this.$router.push(`/signin/tenant?company=${this.companyDataLocal.slug}`);
          } else if (this.$route?.query?.company) {
            this.$router.push(`/signin/tenant?company=${this.$route.query.company}`);
          } else {
            this.$router.push('/signin');
          }
        },
      });
      this.resetStore();
    },
    resetStore() {
      this.$store.commit('auth/resetAuthData');
      this.$store.commit('profile/resetProfileData');
      this.$store.commit('company/resetCompanyData');
      this.$store.commit('auth/resetAuthData', null, { root: true });
      this.$store.commit('company/resetCompanyData', null, { root: true });
      // Reset theme state and CSS variables
      this.$store.dispatch('theme/resetTheme', null, { root: true });
      this.$store.commit('companyDocuments/resetCompanyDocumentsData', null, {
        root: true,
      });
      this.$store.commit('documentGroups/resetDocumentGroupsData', null, {
        root: true,
      });
      this.$store.commit('documentCategories/resetDocumentCategoriesData', null, {
        root: true,
      });

      this.$store.commit('companyBenefits/resetCompanyBenefitsData', null, {
        root: true,
      });
      this.$store.commit('companyTemplates/resetCompanyTemplatesData', null, {
        root: true,
      });
      this.$store.commit('offerLetter/resetOfferLetterData', null, {
        root: true,
      });
      this.$store.commit('employee/resetEmployeesData', null, {
        root: true,
      });
      this.$store.commit('configurableDocuments/resetConfigurableDocuments');

      this.$store.commit('standardDocumentConfig/reset');
      this.$store.commit('employeeData/reset');
      this.$store.commit('employeeDocuments/reset');
      this.$store.commit('workflowData/reset');
      this.$store.commit('workflows/reset');
      this.$store.commit('templatesData/reset');
      this.$store.commit('i9formDocuments/reset');
      this.$store.commit('authorizedRepresentatives/reset');
      this.$store.commit('employeeDocumentAuthorizedUsers/reset');
      this.$store.commit('userRolesForRBAC/setSelectedRole', null);
      this.$store.commit('userRolesForRBAC/setAllRoles', null);
      this.$store.commit('userRolesForRBAC/setAllAssignedRoles', null);
    },
  },
};
